module.exports = __webpack_public_path__ + "static/img/ring.db5246c7.png";